import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {Website} from "./website/website";
import {FormControl} from "@angular/forms";
import {IFcDropdownSelectOption} from "../shared/components/form-controls/dropdown-select/fc-dropdown-select-option";
import {SearchByPropertyPipe} from "../shared/pipes/search-by-property.pipe";

import {combineLatest, Observable, Subject, Subscription} from "rxjs";
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {
  UserSubscription,
  UserSubscriptionCategory,
  UserSubscriptionIds,
  UserSubscriptionType
} from "../user/user-subscription";
import {DialogService} from "../../ng2-bootstrap-modal/dialog.service";
import {Location} from '@angular/common';
import {Store} from '@ngrx/store';
import * as fromStore from '../store';
import {filter, first, map, switchMap, takeUntil} from "rxjs/operators";
import {User} from "../user/user";
import {ActivityStatus} from "../activities/activity";
import {
  AccountUpgradedDialogComponent
} from "../shared/components/dialogs/account-upgraded-dialog/account-upgraded-dialog.component";
import {TextUtils} from "../shared/utils/text-utils";
import {Product} from "./website/product";
import {Config} from "../config/config";
import {AddTagDialogComponent} from "./tag-managment-dialogs/add-tag-dialog/add-tag-dialog.component";
import {TagsListDialogComponent} from "./tag-managment-dialogs/tags-list-dialog/tags-list-dialog.component";
import {DbResponse} from "../shared/interceptors/db-response";
import {WebsiteTag} from "./website/website-tag";
import {HostingService} from "./website/hosting/hosting.service";
import {
  AlreadyHaveAccountDialogComponent
} from "../shared/components/dialogs/already-have-account/already-have-account-dialog.component";
import {GoogleAnalyticsService} from "../shared/services/google-analytics/google-analytics.service";
import {Utils} from "../shared/utils/utils";
import {PerformanceService} from "./website/performance/performance.service";
import {clientRoles} from "../user/user-roles-actions";
import {TypeUtils} from "../shared/utils/type-utils";
import {UserSubscriptionStatus} from "../user/user-subscription-status";
import {DbModalService} from "../modules/modal/modal";
import {Workspace} from "../user-managment/workspace";
import {
  NotificationDialogComponent
} from "../shared/components/dialogs/notification-dialog/notification-dialog.component";
import {CreateWebsiteService} from "../services/local/create-website.service";
import {
  WebsitesEmptyDedicatedHostingComponent
} from "./websites-empty-dedicated-hosting/websites-empty-dedicated-hosting.component";
import {AwsUploadService} from "../shared/services/aws-upload/aws-upload.service";
import * as userActions from "../store/actions/user.action";
import {
  CreateAiAssistantComponent
} from "../components/pages/setup/create-ai/create-ai-assistant/create-ai-assistant.component";
import {GlobalEvent} from "../shared/services/global-event-dispatcher/global-event";
import {GlobalEventDispatcherService} from "../shared/services/global-event-dispatcher/global-event-dispatcher.service";
import {UserService} from "../user/user.service";
import {WebsiteService} from "./website.service";
import {
  OneWeekFreeDemoUpgradeComponent
} from "../shared/components/dialogs/one-month-free/components/one-week-free-demo-upgrade/one-week-free-demo-upgrade.component";
import {
  HostedTrialStartedComponent
} from "../shared/components/dialogs/account-upgraded-dialog/hosted-trial-started/hosted-trial-started.component";
import {OneMonthFreeComponent} from "../shared/components/dialogs/one-month-free/one-month-free.component";
import {
  PricingPageViewComponent
} from "../shared/components/dialogs/one-month-free/components/pricing-page-view/pricing-page-view.component";
import {
  WebsiteCreationStatesDialogComponent
} from "../shared/components/dialogs/website-creation-loading/website-creation-states-dialog.component";
import {DashboardUtils} from "../shared/utils/dashboard-utils";

@Component({
    selector: 'db-websites',
    templateUrl: './websites.component.html',
    styleUrls: ['./websites.component.scss'],
    standalone: false
})

export class WebsitesComponent implements OnInit, OnDestroy {
  public Config = Config;
  public searchTerm: FormControl;
  public sortBy: FormControl;
  public sortByOptions: IFcDropdownSelectOption[] = [];
  public websitesLoading$: Observable<boolean>;
  public websites$: Observable<Website[]>;
  public websites: Website[];
  public filteredWebsites: Website[];
  public userSubscription: UserSubscription;
  public newSubscription: any;
  public fromGoogleSignIn: string;
  public user: User;
  public companyInfo: any;
  public fromUpgradedAccount: boolean;
  public products: Product[];
  public ongoingActivity$: Observable<any>;
  public fromPaypalRecurringMessage: boolean;
  public fromPaypalExecuteAgreementMessage: boolean;
  public selectAll: FormControl;
  public hasCheckedWebsite: boolean;
  public checkedWebsitesCount: number;
  public checkedWebsiteTitle: string;
  public isScrolled: boolean;
  public isClicked: boolean;
  public disableControls: boolean;
  public position: number = 50;
  public scrolled: number = 50;
  public tagsList: WebsiteTag[];
  public allTagFiltersList: WebsiteTag[];
  public dropdownList = [];
  public selectedItems = [];
  public checkedItems = [];
  public hostedTag: WebsiteTag;
  public connectedTag: WebsiteTag;
  public filteredSites: Website[];
  public checkedDomainTypeItems = [];
  public gridFirstElement: number = 4;
  public dropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'title',
    enableCheckAll: false,
    itemsShowLimit: 4
  };
  public UserSubscriptionType = UserSubscriptionType;
  public UserSubscriptionCategory = UserSubscriptionCategory;
  public userSubscriptionIds = UserSubscriptionIds;
  private _websiteSubscriptions: Subscription;
  private _userSubscriptions: Subscription;
  public connectedWebsites: Website[];
  public mobileView: boolean;
  public overlayWebsiteTrial: boolean;
  public loading: boolean;
  public hostedWebsites: Website[];
  public hostedWebsitesWithMulti: Website[];
  public hostedAndSpeedWebsites: Website[];
  public allHostedWebsites: Website[];
  public overlayWebsite: boolean;
  public loadingAfterConnect: boolean;
  public dialogOpened: boolean;
  public scroll: boolean;
  public isSent: boolean;
  /* pagination */
  public currentPage: number = 1;
  public currentPageBeforeFilter: number = 1;
  public itemsPerPage: number = 50;
  public itemsCount: number = 0;
  public pagesCount: number = 0;
  public currentWorkspace: Workspace;
  public canCreateWebsite: boolean;
  public ownerSubscrExpired: boolean = false;
  public clientRoles = clientRoles;
  public onlyTrialsOrPlatforms: boolean;
  public userRole: any;
  public hostingsLimit: number;
  public userLocalStorage: any;
  public _price: number;
  public hideBuyWebsiteButton: boolean;
  public expiredSubscr: boolean;
  public userSubscriptionStatus = UserSubscriptionStatus;
  private _fromBuilderFreeOffer: string | null = null;
  public blured: boolean;
  public selectedWebsitesIds: number[] = [];
  public hideCard: boolean;
  public enabledCdnCount: any;
  public websiteId: any;
  public demoUser: boolean;
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();
  public isAiBuilderDemo: boolean = false;
  public dedicatedHosting: boolean = false;
  public isUploading: boolean = false;
  public uploadingStarted: boolean = false;
  public hasOngoingMigrationActivity: boolean = false;
  public ongoingMigrationActivity: any;
  public emailCampaign: boolean = false;
  public aiBuilderDemoUrl: string = '';
  public hostedWebsitesCount: any;
  zoneIsBeingCreate: boolean;
  showTimeoutView: boolean = false;
  createInstanceActivity: any;
  hasDemoSite: boolean;
  upgradedFromTrial: any;
  importDemoStarted = false;
  firstTime = false;
  private _hostedTrialStarted: string;


  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _location: Location,
    private _searchPipe: SearchByPropertyPipe,
    private _dialogService: DialogService,
    private _hostingService: HostingService,
    private _store: Store<fromStore.DbStoreState>,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _performanceService: PerformanceService,
    private _dbModalService: DbModalService,
    private _modalService: DbModalService,
    private _awsUploadService: AwsUploadService,
    private readonly _createWebsiteService: CreateWebsiteService,
    private _globalEventDispatcher: GlobalEventDispatcherService,
    private _userService: UserService,
    private _websiteService: WebsiteService
  ) {
    this.selectAll = new FormControl("");
  }

  ngOnInit() {
    this.searchTerm = new FormControl('');
    this.userSubscription = this._route.snapshot.data['userSubscription'];
    this.companyInfo = this._route.snapshot.data['companyInfo'];
    this.hideCard = this.userSubscription && (this.userSubscription.type === UserSubscriptionCategory.PLATFORM || this.userSubscription?.isDedicatedVM) && this.userSubscription && this.userSubscription.plan && this.userSubscription.plan.services && !this.userSubscription.plan.services.hosting;
    this.mobileView = window.innerWidth <= 991;
    this.ongoingActivities();
    this._removeLocalStorageData();

    const queryParams: any = (<any>this._route.queryParams).value;
    this.firstTime = queryParams.firstTime;
    const subscriptionId: number = parseInt(queryParams.subscr_id, 10);
    const fromSignup: boolean = queryParams && queryParams.fromSignup && queryParams.fromSignup !== '0';
    const fromGoogleSignIn = queryParams.fromGoogleSignIn;
    const showUpgradePopup = queryParams.showUpgradePopup || window.location.href.indexOf("showUpgradePopup") > -1;
    const updateUser = queryParams.upgraded_account || window.location.href.indexOf("upgraded_account") > -1;
    this._hostedTrialStarted = queryParams.hostedTrialStarted;
    const afterOnboarding = queryParams.afterOnboarding;
    this.emailCampaign = !!queryParams.emailCampaign && !window.location.href.includes('setup-onboarding');
    this._fromBuilderFreeOffer = queryParams.from_builder_free_offer || null;
    this.getUser(fromSignup, subscriptionId, fromGoogleSignIn);
    showUpgradePopup && (this.userSubscription?.trialClient && this.demoUser) && !this._dbModalService.hasOpenModals() && this._showUpgradePopupForWpAdmin(!!afterOnboarding);
    showUpgradePopup && (this.userSubscription?.trialClient && !this.demoUser) && !this._dbModalService.hasOpenModals() && this.showNewTrialPopup();
     if (!!updateUser) {
         setTimeout(() => {
             this._store.dispatch(new fromStore.UpdateUserSubscription());
         }, 3000);
     }
      this.getWebsites(fromSignup);
    this.userLoadedSubscribe();
    this.getQueryParams();
    this._awsIsUploading();
    this._rememberLastChosenTags();
    this._router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this._destroyStream$)
      )
      .subscribe(() => {
        this.getQueryParams();
      });

    if (localStorage.getItem('showFinalize')) {
      localStorage.removeItem('showFinalize');
    }

    if (window.innerWidth > 1900) {
      this.gridFirstElement = 5;
    }

    this.searchTerm.valueChanges.subscribe((): void => {
      this.filterByTags();
      this.updateSelectAllState();
    });
  }

  showNewTrialPopup() {
    this._dbModalService.open(PricingPageViewComponent, {overflowHidden: true, height: 960, width: 1076});
    this.sendGAEvent("Redirect from Builder", "Free trial paywalls");
  }

  openIframe(value) {
    this._globalEventDispatcher.dispatchEvent(GlobalEvent.showDemoPreviewIframe, {showIframe: true, iframeUrl: value});
  }

  private _subscribeToVPSNotifs(hasWebsite: boolean): void {
    this._store.select(fromStore.getOngoingActivities)
      .pipe(
        filter((loaded: any) => loaded),
        switchMap(() => this._store.select(fromStore.getDedicatedInstanceOngoingActivity)),
        filter((activity: any) => activity),
        takeUntil(this._destroyStream$)
      )
      .subscribe((activity) => {
        this.createInstanceActivity = activity;
        switch (activity.status) {
          case ActivityStatus.DONE:
            this.zoneIsBeingCreate = false;
            this.showTimeoutView = false;
            this._globalEventDispatcher.dispatchEvent(GlobalEvent.userInstanceCreating, 0);
            !this.importDemoStarted && this.isDemoUser();
            break;

          case ActivityStatus.PENDING:
          case ActivityStatus.RUNNING:
            this.zoneIsBeingCreate = true;
            this.showTimeoutView = false;
            this._globalEventDispatcher.dispatchEvent(GlobalEvent.userInstanceCreating, 1);
            break;

          case ActivityStatus.FAILED:
            this.zoneIsBeingCreate = false;
            this.showTimeoutView = !hasWebsite;
            this._globalEventDispatcher.dispatchEvent(GlobalEvent.userInstanceCreating, !hasWebsite);
            break;

          default:
            this._globalEventDispatcher.dispatchEvent(GlobalEvent.userInstanceCreating, 0);
            break;
        }
      });
  }

  public isDemoUser() {
    const fromUpgrade = localStorage.getItem('dbForVPSUpgrade');
    if (!TypeUtils.isNull(fromUpgrade) && this.hasDemoSite) {
      this.importDemoStarted = true;
      this._dialogService.addDialog(AccountUpgradedDialogComponent, {
        currentSubscription: this.userSubscription,
        upgradedFromTrial: this.upgradedFromTrial,
        showSetupFlowVPS: true
      });
      return;
    }
  }

  public getDemoSite(): Observable<string | null> {
    /*TODO Hrach REMOVE this after task when we offer paid users to re import demo if something went wrong*/
    return this._websiteService.getAiBuilderDemoWebsite().pipe(
      first(response => !!response),
      map(response => response.success ? response.data?.page_url : null)
    );
  }

  public checkIfInstanceIsCreated(instanceId) {
    this.userLocalStorage['hasCreatedInstance'] = instanceId;
    this._updateLocalStorage();
  }

  private _updateLocalStorage(): void {
    this._userService.setToLocal(this.userLocalStorage)
      .pipe(
        first(response => !!response, null),
      )
      .subscribe(response => {
        if (response.success) {
          this._store.dispatch(new fromStore.LoadUserLocalStorage());
          this._store.dispatch(new fromStore.LoadUser());
        }
      });
  }

  private _getVPZoneCreatedResponse(hasWebsite: boolean): void {
    this._globalEventDispatcher.dispatchEvent(GlobalEvent.userInstanceCreating, 1);
    this.zoneIsBeingCreate = true;
    this._store.dispatch(new fromStore.GetVPZoneCreatedResponse());
    this._store.select(fromStore.getVPZoneCreatedResponse).pipe(
      filter((response: any) => response),
      takeUntil(this._destroyStream$)
    ).subscribe((response: any) => {
      if (response && response.length > 0) {
        this.zoneIsBeingCreate = false;
        this.showTimeoutView = false;
        this._globalEventDispatcher.dispatchEvent(GlobalEvent.userInstanceCreating, 0);
        this.checkIfInstanceIsCreated(response);
        this.isDemoUser();
      } else {
        this.zoneIsBeingCreate = false;
        this.showTimeoutView = !hasWebsite;
        this._globalEventDispatcher.dispatchEvent(GlobalEvent.userInstanceCreating, !hasWebsite);
      }
    });
  }

  private _awsIsUploading(): void {
    this._awsUploadService.isUploading.subscribe(loading => {
      this.isUploading = !!loading;
      if (this.isUploading) {
        this.uploadingStarted = true;
        this.disableControls = true;
      }
    });
  }

  private _removeLocalStorageData(): void {
    if (localStorage.getItem('dbFromSetup')) {
      localStorage.removeItem('dbFromSetup');
    }
  }

  private _showUpgradePopupForWpAdmin(afterOnboarding: boolean): void {
    if (afterOnboarding) {
      this.sendGAEvent('Generative AI - Locked action');
    }
    if (this.demoUser) {
      this.showDemoCheckoutDialog();
    } else {
      const modal = this._dbModalService.open(OneMonthFreeComponent, {height: 600, width: 940});
      if (!!afterOnboarding) {
        modal.componentInstance.mode = 'general';
      } else {
        modal.componentInstance.mode = 'wp-admin';
      }
    }
  }

  public sendGAEvent(eventAction: string, eventCategory?): void {
    const event = {
      eventCategory: eventCategory ? eventCategory : 'Dashboard Action',
      eventAction,
      eventLabel: 'Auto-open popup after onboarding',
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(event);
  }

  public userLoadedSubscribe(): void {
    this._userSubscriptions = this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => combineLatest(
          this._store.select(fromStore.getUserSubscriptionState),
          this._store.select(fromStore.getUser),
        )),
      )
      .subscribe(([userSubscriptionState, user]) => {
        this.user = user;
        this.demoUser = Utils.isDemoUser(this.userSubscription, user);

        if (userSubscriptionState && this.user && (userSubscriptionState.noActiveSubscription || userSubscriptionState.subscriptionExpired)) {
          if ([clientRoles.COMPANY_ADMIN, clientRoles.OWNER].includes(this.currentWorkspace?.roleId) && this.currentWorkspace && !['invited'].includes(this.currentWorkspace.status)) {
            this._router.navigate(['/workspace/subscription-plan']);
            return;
          } else {
            this.ownerSubscrExpired = true;
          }
        }
      });
  }

  public getWebsites(fromSignup): void {
    this.websitesLoading$ = this._store.select(fromStore.getWebsitesLoading);
    this.websites$ = <any>this._store.select(fromStore.getWebsites);
    this._store
      .select(fromStore.getWebsitesLoaded)
      .pipe(
        filter((loaded: boolean): boolean => !!loaded),
        switchMap(() => this._store.select(fromStore.getWebsites)),
        first()
      )
      .subscribe((websites: Website[]) => {
        websites && websites.length && websites[0] && this._hostedTrialStarted && this._openCongratsHostedTrialFlow(websites);
        this.hostedWebsitesCount = websites.filter(website => !website.parentId && website.isActive && website.type === 'live' && !!website.domain_hash).length;
        const _agreementDayDiff = Utils.getDaysDiffFromToday(this.userSubscription?.agreementDate, false);
        this.allHostedWebsites = websites.filter((website: Website) => !website.parentId && website.isActive && !!website.domain_hash);
        if (this.user && this.userSubscription && ((!this.user.hostingTrialExpired && this.userSubscription.trialClient) || (this.userSubscription && this.userSubscription.platformPaidClient && +_agreementDayDiff < 8) || (this.user && this.user.isSuspected))) {
          this.whiteListIp();
        }
      });
    this._store
      .select(fromStore.getWebsitesLoaded)
      .pipe(
        filter((loaded: boolean): boolean => !!loaded),
        switchMap(() => combineLatest(
          this._store.select(fromStore.getWebsites),
          this._store.select(fromStore.getUserLocalStorage)))
      )
      .subscribe(([websites, userLocalStorage]) => {
        this.userLocalStorage = userLocalStorage;
        this.hasDemoSite = !!websites.find((website: Website) => this.userSubscription && !this.userSubscription.trialClient && website.isAiBuilderDemo);
        if (this.userSubscription?.isDedicatedVM && userLocalStorage && !userLocalStorage['hasCreatedInstance']) {
          setTimeout(() => {
            if (!this.createInstanceActivity) {
              this._getVPZoneCreatedResponse(websites?.length > 0);
            }
          }, 10000);
        }
        this.userSubscription?.isDedicatedVM && this._subscribeToVPSNotifs(websites?.length > 0);
        this.selectAll.setValue(false);
        this.hasCheckedWebsite = false;
        this.dedicatedHosting = (this.userSubscription && !!this.userSubscription.dedicatedHosting && !websites.length && this.user && !this.user.websiteCreated);
        const websitesIds: number[] = websites.map(website => website && website.id);
        const websiteDemo = websites.find(website => website?.isAiBuilderDemo);
        if (websiteDemo !== undefined && this.userSubscription && this.userSubscription.category === UserSubscriptionCategory.STARTER) {
          this.isAiBuilderDemo = true;
          this.aiBuilderDemoUrl = websiteDemo.site_url;
        } else {
          this.isAiBuilderDemo = false;
          this.aiBuilderDemoUrl = '';
        }
        this.websites = websites.filter(website => (website.type === 'live' || (website.type === 'staging' && !websitesIds.includes(website.siblingId.live))) && !website.parentId);
        if (this.userSubscription && this.userSubscription.category === UserSubscriptionCategory.STARTER
          && websites && websites.length && !!this._fromBuilderFreeOffer) {
          const matchedWebsite = websites.find(website => {
            return website.site_url === this._fromBuilderFreeOffer;
          });
          this._fromBuilderFreeOffer = null;
          !!matchedWebsite && this.showCheckoutDialog('Builder banner');
        }
        this.initFilters();
        this.setPaginationData();
        this.checkedItems = [];
        this.selectedItems = [];
        this.hostedWebsites = websites.filter((website: Website) => !website.parentId && !website.isNetwork && website.isActive && website.type === 'live' && !!website.domain_hash);
        // this.emailCampaign && websiteDemo && !this._dbModalService.hasOpenModals() && this.user &&  this._showRegeneratePopup();
        this.hostedWebsitesWithMulti = websites.filter((website: Website) => !website.parentId && website.isActive && website.type === 'live' && !!website.domain_hash);
        this.hostedAndSpeedWebsites = websites.filter((website: Website) => !website.parentId && website.isActive && website.type === 'live' && (!!website.domain_hash || website.connectedFrom === 'speed_optimizer'));
        this.allHostedWebsites = websites.filter((website: Website) => !website.parentId && website.isActive && !!website.domain_hash);
        this.enabledCdnCount = websites.filter((website: Website) => !!website.cloudflareEnabled);
        const oneMonthFreeWithAvailableDomains = this.userSubscription && this.userSubscription.freeDaysBeforePayment && !this.disableControls
          && this.hostedWebsitesWithMulti.length < this.hostingsLimit
          && !this.mobileView
          && this.currentWorkspace?.roleId !== clientRoles.SITE_DEV && this.hostedWebsitesWithMulti.length < this.hostingsLimit;
        if (fromSignup && this.user && (this.user.subscriptionId !== this.userSubscriptionIds.TRIAL || (this.user.subscriptionId === this.userSubscriptionIds.TRIAL && this.websites.length)) && !this.dialogOpened) {
          // this.showUserHasAccountDialog();
          this.dialogOpened = true;
        }
        if ((this.checkedDomainTypeItems.length && this.checkedDomainTypeItems.includes("hosted") && this.checkedDomainTypeItems.includes("connected")) || !this.checkedDomainTypeItems.length) {
          this.filteredSites = this.websites;
        } else {
          this.filteredSites = this.checkedDomainTypeItems.includes("hosted") ? this.websites.filter((website: Website): boolean => !!website.domain_hash) : this.websites.filter((website: Website): boolean => !website.domain_hash);
        }

        this.searchTerm && (this.filteredWebsites = <Website[]>this._searchPipe.transform(this.filteredSites, {
          'site_url': Utils.removeTrailingSlashes(this.searchTerm.value),
          'title': this.searchTerm.value
        }));

        if (this.userSubscription && (this.userSubscription.trialClient || this.userSubscription.trialBoosterClient || this.userSubscription.freeBaseClient || this.userSubscription.subscriptionId === Config.defaultStarterPlanId) && !this.loading) {
          this.connectedWebsites = websites.filter((website: Website) => !website.parentId && !website.isNetwork && website.isActive && website.type === 'live' && !website.domain_hash);
          this.overlayWebsite = !!this.websites.find((website: Website) => website.migrated_from && this.connectedWebsites && this.connectedWebsites[0] && website.migrated_from.replace(/(^\w+:|^)\/\//, '') === this.connectedWebsites[0].site_url.replace(/(^\w+:|^)\/\//, ''));
          this.overlayWebsiteTrial = !!websites.find((website: Website) => website.domain_hash && website.isActive && !website.isLocalhost && !website.isNetwork && (!website.migrated_from || (this.connectedWebsites && this.connectedWebsites.length && website.migrated_from && this.connectedWebsites && this.connectedWebsites[0] && website.migrated_from.replace(/(^\w+:|^)\/\//, '') !== this.connectedWebsites[0].site_url.replace(/(^\w+:|^)\/\//, ''))));
        }
        /*      if (this.hostedWebsites && this.hostedWebsites.length) {
                this.scoreRecheck(this.hostedWebsites);
              }*/
      });
  }

  public getUser(fromSignup, subscriptionId, fromGoogleSignIn): void {
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => combineLatest(
          this._store.select(fromStore.getUser),
          this._store.select(fromStore.getUserSubscription),
          this._store.select(fromStore.getCurrentWorkspace),
          this._store.select(fromStore.getWorkspaceIdEntities)
        )),
        takeUntil(this._destroyStream$)
      )
      .subscribe(([user, userSubscription, currentWorkspace, workspaceIdEntities]) => {
        this.user = user;
        this.demoUser = Utils.isDemoUser(userSubscription, user);
        this.userSubscription = userSubscription;
        this.hostingsLimit = this.user && this.user.hosting_services && this.userSubscription && this.userSubscription.plan ?
          parseInt(this.user.hosting_services.domain_count.parameter_value, 10) : null;
        if (this.user && this.userSubscription) {
          this.onlyTrialsOrPlatforms = this.userSubscription.trialClient || this.userSubscription.trialBoosterClient || this.userSubscription.freeBaseClient || this.userSubscription.trialOptimizerClient || this.user.platformClient;
        }
        this.currentWorkspace = currentWorkspace;
        this.userRole = this.user && this.user.workspaces.find(el => el.workspaceId === workspaceIdEntities.currentWorkspaceId).roleId;
        this.hideBuyWebsiteButton = this.userRole ? [clientRoles.COMPANY_DEV, clientRoles.SITE_DEV].includes(this.userRole) : true;
        this.canCreateWebsite = currentWorkspace && currentWorkspace.roleId !== clientRoles.SITE_DEV;
        let expired = this.userSubscription && ([this.userSubscriptionStatus.canceled, this.userSubscriptionStatus.failed, this.userSubscriptionStatus.expired].includes(this.userSubscription.status) || this.userSubscription.isExpired || this.userSubscription.recharge);
        this.expiredSubscr = expired || (this.userSubscription && this.userSubscription.recharge);
        if (this.userSubscription && this.userSubscription.plan && this.userSubscription.plan.additionalDomainParameterPrice) {
          this._price = this.userSubscription.plan.periodNumber === 12 ? this.userSubscription.plan.additionalDomainParameterPrice / 12 : this.userSubscription.plan.additionalDomainParameterPrice;
          if (this._price % 1 !== 0) {
            this._price = Number(this._price.toFixed(2));
          }
        }
      });
  }

  public ongoingActivities(): void {
    this._store.select(fromStore.getOngoingActivities)
      .pipe(
        filter((loaded: any) => loaded),
        switchMap(() => combineLatest(
          this._store.select(fromStore.getMigrationOngoingActivity),
          this._store.select(fromStore.getCreateWebsiteOngoingActivity),
          this._store.select(fromStore.getAddWebsiteOngoingActivity)
        )),
        takeUntil(this._destroyStream$)
      )
      .subscribe(([migrationActivity, createActivity, addWebsiteActivity]) => {

        if (!migrationActivity && !createActivity && !addWebsiteActivity) {
          return;
        }
        if (!!addWebsiteActivity && this.userSubscription && ((this.userSubscription.trialClient || this.userSubscription.trialBoosterClient || this.userSubscription.freeBaseClient) || this.userSubscription.subscriptionId === Config.defaultStarterPlanId) && !this.loading) {
          this.loadingAfterConnect = !!(this.connectedWebsites && this.connectedWebsites[0] && addWebsiteActivity.websiteId && addWebsiteActivity.websiteId === this.connectedWebsites[0].id);
        }

        if (migrationActivity && !this._dbModalService.hasOpenModals() && !this._modalService.hasOpenModals() && !this._dialogService.hasOpenedDialog()) {
          this._createWebsiteService.openMigrateWebsiteModal(migrationActivity.websiteId ? migrationActivity.websiteId : null, null, migrationActivity.status === ActivityStatus.RUNNING, true, migrationActivity?.meta?.is_clone === true);
        }

        if (migrationActivity) {
          this.hasOngoingMigrationActivity = true;
          this.ongoingMigrationActivity = migrationActivity;
        }

        const ongoingActivity = migrationActivity ? migrationActivity : (createActivity ? createActivity : addWebsiteActivity);
        switch (ongoingActivity.status) {
          case ActivityStatus.DONE:
          case ActivityStatus.FAILED:
            this.disableControls = false;
            this.uploadingStarted = false;
            this.hasOngoingMigrationActivity = false;
            this.loading = false;
            this._store.dispatch(new userActions.LoadUserSubscription());
            break;
          case ActivityStatus.RUNNING:
            this.disableControls = true;
            this.loading = true;
            break;
          default:
            this.disableControls = true;
            break;
        }
      });
  }

  private setPaginationData(): void {
    this.itemsCount = this.websites && this.websites.length;
    this.pagesCount = Math.ceil(this.itemsCount / this.itemsPerPage);
  }

  public onChangePage(page: number, filtered: boolean = false): void {
    this.currentPage = page;
    if (!filtered) {
      this.currentPageBeforeFilter = page;
    }
    if (this.searchTerm.value === '' && !this.checkedItems.length && !this.checkedDomainTypeItems.length) {
      this.currentPage = this.currentPageBeforeFilter;
    }
  }

  private showSuccessfullyUpgradedDialog(upgradedFromTrial, upgradedFromBooster): void {
    localStorage.removeItem('dbCouponFromEmail');
    this._dialogService.addDialog(AccountUpgradedDialogComponent, {
      currentSubscription: this.userSubscription,
      upgradedFromTrial: upgradedFromTrial,
      upgradedFromBooster: upgradedFromBooster
    });
  }

  public toggleAllItemsSelected(selected: boolean): void {
    this.filteredWebsites.forEach((website: Website): void => {
      if (website.isActive) {
        website.selected = selected;
      }
    });
    this.searchTerm && (this.filteredWebsites = <Website[]>this._searchPipe.transform(this.filteredWebsites, {
      'site_url': Utils.removeTrailingSlashes(this.searchTerm.value),
      'title': this.searchTerm.value
    }));
    this.updateSelectAllState();
  }

  public updateSelectAllState(): void {
    this.hasCheckedWebsite = false;
    this.checkedWebsitesCount = 0;
    this.selectedWebsitesIds = [];
    this.filteredWebsites.map((website: Website): any => {
      if (website.selected && website.isActive && !website.isLocalhost) {
        this.selectedWebsitesIds.push(website.id);
        this.hasCheckedWebsite = true;
        this.checkedWebsiteTitle = '"' + website.title + '"';
        this.checkedWebsitesCount++;
      }
    });
    let selectAllToggled = false;
    if (this.filteredWebsites.length > 1 || (this.filteredWebsites.length === 1 && this.filteredWebsites[0].isActive)) {
      selectAllToggled = !this.filteredWebsites.find((website: Website): boolean => !website.selected && website.isActive);
    }
    this.selectAll.setValue(selectAllToggled);
  }

  public showAddTagDialog() {
    this.isClicked = true;
    setTimeout(() => {
      this.isClicked = false;
    }, 500);

    if (this.tagsList && this.tagsList.length) {
      this._dialogService.addDialog(TagsListDialogComponent, {
        domainIds: this.selectedWebsitesIds,
        tagsList: this.tagsList
      }).subscribe((reopenLast: boolean): void => {
        if (reopenLast) {
          this.toggleAllItemsSelected(false);
        }
      });
    } else {
      this._dialogService.addDialog(AddTagDialogComponent, {
        domainIds: this.selectedWebsitesIds,
        hideBackButton: true
      });
    }
  }

  public addWebsiteDialog(firstTime = false, redirect: boolean = false) {
    if (redirect) {
      this._router.navigate(['/add-website']);
    }
  }

  public getUserSubscription(subscriptionId: number): void {
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getUserAvailableSubscriptions())),
        first()
      )
      .subscribe((userAvailableSubscriptions: UserSubscription[]) => {
        this.newSubscription = userAvailableSubscriptions.find((userSubscription: UserSubscription): boolean => {
          return userSubscription && userSubscription.id === subscriptionId;
        });
      });
  }

  private initFilters(): void {
    this.sortBy = new FormControl('filterByTag');
    this.sortByOptions = [
      {
        value: 'filterByTag',
        label: ''
      }
    ];
    this.getTagsList();
  }

  public getTagsList(): void {
    if (this.websites && this.websites.length) {
      this._store.select(fromStore.getWebsiteTags())
        .pipe(
          takeUntil(this._destroyStream$)
        )
        .subscribe((tags: any) => {
          if (tags) {
            this.tagsList = (tags.length && tags) || [];
            this.allTagFiltersList = [...this.tagsList];

            this.hostedTag = {
              id: 0,
              title: 'Hosted',
              clientId: this.user && parseInt(this.user.id, 10) || null,
              clickedValue: 'all',
              allDomainsHas: false,
              someDomainsHas: 'all',
              domains: []
            };

            this.connectedTag = {
              id: 1,
              title: 'Connected',
              clientId: this.user && parseInt(this.user.id, 10) || null,
              clickedValue: 'all',
              allDomainsHas: false,
              someDomainsHas: 'all',
              domains: []
            };

            if (this.currentWorkspace && this.currentWorkspace.roleId === clientRoles.OWNER) {
              if (this.userSubscription && (this.userSubscription.boosterProClient || this.userSubscription.trialBoosterClient)) {
                this.allTagFiltersList.unshift(this.connectedTag);
              } else {
                this.allTagFiltersList.unshift(this.hostedTag, this.connectedTag);
              }
            }
            this.dropdownList = this.allTagFiltersList.map((tag: WebsiteTag): any => {
              return {
                id: tag.id,
                title: tag.title,
                isDisabled: false
              };
            });
          }
        });
    }
  }

  public onItemSelect(item: any = [], deselect: boolean = false) {
    this.filterByTagsList(item, deselect);
    this.onChangePage(1, true);
    this.setPaginationData();
  }

  private _rememberLastChosenTags(): void {
    // Check if there are stored options in sessionStorage
    let storedOptions = sessionStorage.getItem('lastSelectedTags');
    let choosedOptions = JSON.parse(storedOptions);

    if (!TypeUtils.isEmpty(choosedOptions)) {
      // Parse the JSON string to an array
      choosedOptions.forEach(item => this.onItemSelect(item, false));
    }
  }

  public filterByTagsList(item: any, deselect: boolean): void {
    let checkedTags = JSON.parse(sessionStorage.getItem('lastSelectedTags')) || [];
    let index = checkedTags.findIndex(tag => tag && tag.id === item.id);


    if (!deselect) {
      // If the checkbox is checked, add the item title to the array
      if (index === -1) {
        checkedTags.push(item);
      }
    } else {
      // If the checkbox is unchecked, remove the item title from the array
      if (index !== -1) {
        checkedTags.splice(index, 1);
      }
    }

    if (!deselect) {
      this.checkedItems.push(item.title);
    } else {
      this.checkedItems.splice(this.checkedItems.indexOf(item.title), 1);
    }

    if (!deselect) {
      this.createMoreTagsDiv();
    }

    this.filterByTags();
    this.selectedItems = checkedTags;
    sessionStorage.setItem('lastSelectedTags', JSON.stringify(checkedTags));

  }

  public createMoreTagsDiv(): void {
    /* include items in tags-list div */
    if (document.getElementsByClassName("selected-item").length >= 4) {
      document.getElementById("tags-list").innerHTML = '';
      setTimeout(() => {
        const node = document.getElementsByClassName("dropdown-btn")[0].querySelectorAll('[hidden]');
        node.forEach((parent, i) => {
          const original = node[i];
          const clone = original.cloneNode(true);
          (<HTMLElement>clone).classList.add('cloned_element');
          document.getElementById("tags-list").appendChild(clone);
        });
      });
    }
  }


  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: any): void {
    // Clear sessionStorage before the page is unloaded
    sessionStorage.removeItem('lastSelectedTags');
  }

  @HostListener('document:mousemove', ['$event']) onMouseMove($event: any) {
    /* add id to +1 selected_item div for find easier with more_tags_list id */
    const moreTagsSpan = document.querySelector('.db-websites__dropdown-select-trials .selected-item[hidden] + span > span:first-child');
    moreTagsSpan && moreTagsSpan.setAttribute("id", "more_tags_list");
    if ($event.target && $event.target.id && $event.target.id === 'more_tags_list') {
      $event.target.appendChild(document.getElementById('more_filtered_tags'));
    }
  }

  @HostListener('document:click', ['$event']) onDocumentClick($event: any) {
    if ($event.target && $event.target.parentElement && $event.target.parentElement.classList
      && $event.target.parentElement.classList.contains('cloned_element')) {
      /* remove spaces */
      const getClonedTagTitle = $event.target.parentElement.childNodes[0].textContent.replace(/\s/g, '');
      const getClonedElement = this.allTagFiltersList.find((tag) => tag.title = getClonedTagTitle);

      /* change selected items array after deselect from more_tags div */
      this.selectedItems = this.selectedItems.filter((item) => item.title !== getClonedElement.title);
      this.onItemSelect(getClonedElement, true);

      /* remove deselected item */
      $event.target.parentElement.remove();
    }
  }

  public filterByTags(): void {
    const websiteList = this.checkedItems.length ? this.filteredSites.reduce((websitesByTag: any[], website: Website): any[] => {
      Object.values(website.tags).map((websiteTag: any) => {
        if (this.checkedItems.length && this.checkedItems.includes(websiteTag)
          && !websitesByTag.find((websiteByTag: Website): any => websiteByTag.id === website.id)) {
          websitesByTag.push(website);
        }
      });
      return websitesByTag;
    }, []) : this.filteredSites;
    this.searchTerm && (this.filteredWebsites = <Website[]>this._searchPipe.transform(websiteList, {
      'site_url': Utils.removeTrailingSlashes(this.searchTerm.value),
      'title': this.searchTerm.value
    }));
    this.setPaginationData();
  }

  public refreshClicked(): void {
    this._store.dispatch(new fromStore.LoadWebsites());
  }


  private showSuccessfullyAdditionalDialog(siteCount: number, cdnCount: number) {
    localStorage.removeItem('dbFromAdditional');
    const websiteIdFromBoosterHosting = localStorage.getItem('dbWebsiteIdForBooster');
    const fromCreateCardFromBooster = localStorage.getItem('dbFromCreateCardBooster');
    let messageText: string;
    let buttonText: string;
    if (siteCount && cdnCount) {
      messageText = TextUtils.getText('text_addAdditionalWebsiteAndCdnMessage', {
        siteCount: Utils.wordByCount('additional website', siteCount, true),
        cdnCount: Utils.wordByCount('Cloudflare Enterprise CDN add-on', cdnCount, true)
      });
      buttonText = TextUtils.getText('text_availableWebsitesGotIt');
    } else if (!siteCount && cdnCount) {
      messageText = TextUtils.getText('text_addAdditionalCdnMessage', {cdnCount: Utils.wordByCount('website', cdnCount, true)});
      buttonText = TextUtils.getText('text_addPaymentMethodSubscriptionSuccessButton');
    } else if (siteCount && this.userSubscription && this.userSubscription.boosterProClient && TypeUtils.isDefined(fromCreateCardFromBooster) && TypeUtils.isNull(websiteIdFromBoosterHosting)) {
      messageText = TextUtils.getText('text_hostingAddOnForBoosterMessageFromCreate', {number: Utils.wordByCount('website', siteCount, true)});
      buttonText = TextUtils.getText('text_proceed');
    } else if (siteCount && this.userSubscription && this.userSubscription.boosterProClient && TypeUtils.isDefined(websiteIdFromBoosterHosting)) {
      messageText = TextUtils.getText('text_hostingAddOnForBoosterMessage', {number: Utils.wordByCount('website', siteCount, true)});
      buttonText = TextUtils.getText('text_proceed');
    } else {
      messageText = TextUtils.getText(!siteCount ? 'text_addAdditionalWebsiteSuccessMessage' : 'text_addAdditionalWebsiteMessage', {count: Utils.wordByCount('additional website', siteCount, true)});
      buttonText = TextUtils.getText('text_availableWebsitesGotIt');
    }

    this._dialogService
      .addDialog(NotificationDialogComponent, {
        header: TextUtils.getText('text_accountUpgradedHeader'),
        message: messageText,
        buttonText: buttonText,
        buttonAlign: 'center',
        action: this.userSubscription && this.userSubscription.boosterProClient
        && TypeUtils.isNull(websiteIdFromBoosterHosting) && TypeUtils.isDefined(fromCreateCardFromBooster) ? 'start' : ''
      }).subscribe((confirmed: string): void => {
      if (confirmed === 'start') {
        this._createWebsiteService.openCreateWebsiteModal(this.userSubscription && this.userSubscription.boosterProClient);
      }
    });

    TypeUtils.isDefined(websiteIdFromBoosterHosting) && !TypeUtils.isNull(websiteIdFromBoosterHosting) && this._router.navigate([`/websites/${websiteIdFromBoosterHosting}/booster/hosting-performance`]);
    localStorage.removeItem('dbWebsiteIdForBooster');
    localStorage.removeItem('dbFromCreateCardBooster');
  }

  private showUserHasAccountDialog(): void {
    this._dialogService.addDialog(AlreadyHaveAccountDialogComponent);
  }

  private async scoreRecheck(websites: Website[]) {

    const now: number = Date.now();
    const day: number = 1000 * 60 * 60 * 24;
    const week: number = day * 7;
    let initialUpdate: boolean;
    let weekUpdate: boolean;

    for (const website of websites) {
      if (website && website.score && website.score.currentScore && website.score.currentScore.date) {
        initialUpdate = website.score.currentScore.desktopScore === 100 && (now - new Date(website.score.currentScore.date).getTime()) > day;
        weekUpdate = (now - new Date(website.score.currentScore.date).getTime()) > week;
        if (initialUpdate || weekUpdate) {
          await new Promise((resolve: Function, reject: Function): void => {
            this._performanceService.runWarmUpPerformance(website.id)
              .pipe(filter((response: DbResponse): boolean => !!response),
                first())
              .subscribe((response: DbResponse): void => {
                if (response) {
                  this._performanceService.getGooglePageSpeedScore(website.id)
                    .pipe(filter((_response: DbResponse): boolean => !!_response),
                      first())
                    .subscribe((_response: DbResponse): void => {
                      if (response) {
                        resolve(true);
                      }
                    });
                }
              });
          });
        }
      }
    }
  }

  private whiteListIp() {
    if (this.allHostedWebsites && this.allHostedWebsites.length) {
      const websiteId = this.allHostedWebsites[0].isNetwork && this.allHostedWebsites[0].children ? this.allHostedWebsites[0].children[0] : this.allHostedWebsites[0].id;
      this.allHostedWebsites && this.allHostedWebsites[0] && this.allHostedWebsites[0] && !this.allHostedWebsites[0]?.isAiBuilderDemo && websiteId && this._hostingService.whiteListIp(websiteId, this.allHostedWebsites[0].site_url);
    }
  }

  private removeEventHandlers() {
    if (this._websiteSubscriptions) {
      this._websiteSubscriptions.unsubscribe();
    }

    if (this._userSubscriptions) {
      this._userSubscriptions.unsubscribe();
    }
  }

  ngOnDestroy(): void {
    this.removeEventHandlers();
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }

  private showCheckoutDialog(label: 'Create' | 'Migrate' | 'Builder banner' | 'Optimize'): void {
    const analyticsData = {
      eventCategory: (this.demoUser ? 'Free Upgrade Offer' : 'Free trial paywalls'),
      eventAction: "Locked button click",
      eventLabel: label
    };
    const modal = this._dbModalService.open(OneMonthFreeComponent, {height: 600, width: 940});
    modal.componentInstance.mode = label === 'Builder banner' ? 'editor' : label === 'Optimize' ? 'optimize' : 'creation';
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }

  private _handleRemixFlow(sourceDomainId: any, websiteId?: any, siteUrl?: any): void {
    const sourceDomainIdNumber = parseInt(sourceDomainId, 10);
    const targetDomainIdNumber = parseInt(websiteId, 10);

    if (!isNaN(sourceDomainIdNumber)) {
      this._openRemixDialog(sourceDomainIdNumber, isNaN(targetDomainIdNumber) ? null : targetDomainIdNumber, siteUrl);
    }
  }

  private _openRemixDialog(sourceDomainId: number, websiteId?: number, siteUrl?: string): void {
    const modal = this._dbModalService.open(WebsiteCreationStatesDialogComponent, {
      width: 500,
      height: 228,
      hasCloseBtn: false
    });
    modal.componentInstance.step = 'remix';
    modal.componentInstance.user = this.user;
    modal.componentInstance.userSubscription = this.userSubscription;
    modal.componentInstance.websiteId = websiteId;
    modal.componentInstance.sourceDomainId = sourceDomainId;
    modal.componentInstance.siteUrl = siteUrl;
  }

  private getQueryParams(): void {
    const queryParams = this._route.snapshot.queryParams;
    this.fromPaypalRecurringMessage = window.location.href.indexOf("from_paypalrecurring") > -1 || queryParams['from_paypalrecurring'];
    this.fromPaypalExecuteAgreementMessage = window.location.href.indexOf("from_paypalrecurringMessage") > -1 || queryParams['from_paypalrecurringMessage'];

    if (queryParams['remix'] === '1' && queryParams['source_domain_id']) {
      this._handleRemixFlow(queryParams['source_domain_id'], queryParams['domain_id'], queryParams['site_url']);
    }

    const fromAdditionalWebsite = window.location.href.indexOf("additonal_website") > -1 || queryParams['additonal_website'];
    const fromAdditionalCdn = window.location.href.indexOf("additonal_cdn") > -1 || queryParams['additonal_cdn'];
    if (fromAdditionalWebsite || fromAdditionalCdn) {
      const additionalWebsitesCount = parseInt(queryParams['additonal_website'], 10) || 0;
      const additionalCdnCount = parseInt(queryParams['additonal_cdn'], 10);
      if (this.userSubscription && this.userSubscription.dedicatedHosting) {
        const modal = this._modalService.open(WebsitesEmptyDedicatedHostingComponent, {height: 562, width: 700});
        modal.componentInstance.userSubscription = this.userSubscription;
        modal.componentInstance.fromDialog = true;
      } else {
        this.showSuccessfullyAdditionalDialog(additionalWebsitesCount, additionalCdnCount);
      }
    }

    const queryParamsIndex: number = this._router.url.indexOf('?');
    if (queryParamsIndex !== -1) {
      this._location.replaceState(this._router.url.substring(0, queryParamsIndex));
    }
  }

  private _createAiAssistantDialog(): void {
    const modal = this._modalService.open(CreateAiAssistantComponent, {fullHeight: true});
    modal.componentInstance.websiteId = this.hostedWebsites[0].id;
    modal.componentInstance.isOnboarding = false;
    modal.componentInstance.forceOutlineVersion = true;
    modal.componentInstance.isFromGenerate = true;
    modal.componentInstance.showAsDialog = true;
  }

  showDemoCheckoutDialog() {
    const firstTime = TypeUtils.isNull(localStorage.getItem('dbShowFirstTime'));
    const options = {
      overflowHidden: false,
    };
    if (!firstTime) {
      options['width'] = 1240;
    } else {
      options['width'] = 460;
      options['height'] = 600;
    }
    const modal = this._modalService.open(OneWeekFreeDemoUpgradeComponent, options);
    modal.componentInstance.showFirstTime = firstTime;
  }

  private _openCongratsHostedTrialFlow(websites) {
    const modal = this._modalService.open(HostedTrialStartedComponent, {width: 1000, height: 600, hasCloseBtn: false});
    modal.componentInstance.user = this.user;
    modal.componentInstance.subHeader = this._hostedTrialStarted === 'blank' ? 'Welcome to 10Web' : 'Your website is ready!';
    modal.componentInstance.icon = this._hostedTrialStarted !== 'blank';
    modal.componentInstance.flow = this._hostedTrialStarted === 'blank' ? false : this._hostedTrialStarted;
    modal.componentInstance.userSubscription = this.userSubscription;
    modal.componentInstance.website = websites[0];
    modal.closed.subscribe(() => {
      const websiteUrl = `${websites[0]?.site_url}/?trial_hosted_flow=1${websites[0]?.isEcommerceWebsite ? '&ecommerce=1' : ''}`;
      const previewLink = DashboardUtils.generateWpAdminRedirectorUrl(websites[0]?.id, websiteUrl, this.user?.email);
      if (this._hostedTrialStarted !== 'blank' ) {
        window.open(previewLink, "_blank", "noopener");
      }
      this._router.navigate([`websites/${websites[0].id}/main`]);
    });
    modal.dismissed.subscribe(() => {
      const websiteUrl = `${websites[0]?.site_url}/?trial_hosted_flow=1${websites[0]?.isEcommerceWebsite ? '&ecommerce=1' : ''}`;
      const previewLink = DashboardUtils.generateWpAdminRedirectorUrl(websites[0]?.id, websiteUrl, this.user?.email);
      window.open(previewLink, "_blank", "noopener");
      this._router.navigate([`websites/${websites[0].id}/main`]);
    });
  }
}

